module.exports = __webpack_public_path__ + "static/media/m1.d59bbc3a900f453a0a3360255acfcfb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/m1.png
// module id = 5007
// module chunks = 1